var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21967 16.2197C7.92678 16.5126 7.92678 16.9874 8.21967 17.2803C8.51256 17.5732 8.98744 17.5732 9.28033 17.2803L14.2803 12.2803C14.5732 11.9874 14.5732 11.5126 14.2803 11.2197L9.28033 6.21967C8.98744 5.92678 8.51256 5.92678 8.21967 6.21967C7.92678 6.51256 7.92678 6.98744 8.21967 7.28033L12.6893 11.75L8.21967 16.2197Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.75L14.5 16.75C14.5 17.1642 14.8358 17.5 15.25 17.5C15.6642 17.5 16 17.1642 16 16.75L16 6.75C16 6.33579 15.6642 6 15.25 6C14.8358 6 14.5 6.33579 14.5 6.75Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPageIcon);
export default __webpack_public_path__ + "static/media/LastPageIcon.c1d3fb360e25ee6daf00297ec20209ac.svg";
export { ForwardRef as ReactComponent };